module.exports = __webpack_public_path__ + "june-24-2.jpg?4e077ac92fccf321fbbb340d0f7aaa9a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/june-24-2.jpg
// module id = 217
// module chunks = 0